<template>
  <div>
    <router-view></router-view>
    <van-tabbar  v-model="active" route  style="background-color: #061731" >
      <!-- <van-tabbar-item to="/home" icon="wap-home-o">首页</van-tabbar-item>
      <van-tabbar-item to="/category" icon="apps-o">团队</van-tabbar-item>
      <van-tabbar-item to="/cart" icon="shopping-cart-o">购物车</van-tabbar-item> 
      <van-tabbar-item to="/user" icon="user-o">我的</van-tabbar-item> -->
      <van-tabbar-item  to="/home" >
        <span :style="{color:(active == 0 ? '#15c8f0' : '')}">首页</span>
        <img slot="icon"  :src="active  == 0? icon.indexActive : icon.index"  class="tabbar_icon" />
      </van-tabbar-item>
      <van-tabbar-item  to="/team">
        <span :style="{color:(active == 1 ? '#15c8f0' : '')}">团队</span>
        <img slot="icon" :src="active  == 1? icon.teamActive : icon.team" class="tabbar_icon"/>
      </van-tabbar-item>
      <van-tabbar-item  to="/my">
        <span :style="{color:(active == 2 ? '#15c8f0' : '')}">我的</span>
        <img slot="icon"  :src="active  == 2 ? icon.myActive : icon.my" class="tabbar_icon"/>
      </van-tabbar-item>
     
    </van-tabbar>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: "layoutIndex",
  setup() {
    const icon=  {
            index: require("@/assets/index_default.png"),
            indexActive: require("@/assets/index_active.png"),
            team: require("@/assets/team_default.png"),
            teamActive: require("@/assets/team_active.png"),
            my: require("@/assets/my_default.png"),
            myActive: require("@/assets/my_active.png"),
    }
    return { icon };
  },
  data() {
    return {
      list: [],
      active: 0,
    };
  },
  watch: {
    // 监听路由变化，同步 activeTab
    $route(to) {
      console.log(to)
      if (to.path === '/home') {
        this.active = 0;
      }
     
      if (to.path === '/team'){
         this.active = 1;
       }
       if (to.path === '/company'){
         this.active = 0;
       }
       if (to.path === '/my'){
         this.active = 2;
       }
       if (to.path === '/contact'){
         this.active = 2;
       }
       if (to.path === '/rechargeable'){
         this.active = 2;
       }
       if (to.path === '/draw'){
         this.active = 2;
       }
       if (to.path === '/auditing'){
         this.active = 2;
       }
       if (to.path === '/income'){
         this.active = 2;
       }
       if (to.path === '/notice'){
         this.active = 2;
       }
       
       console.log( this.active)
    },
    
  },
  created() {
    // 初始化时根据路由设置 activeTab
    this.updateActiveTab();
  },
  methods: {
    updateActiveTab() {
      const path = this.$route.path;
      console.log( path)
      if (path === '/home') {
        this.active = 0;
      }
     
      if (path === '/team'){
         this.active = 1;
       }
       if (path === '/company'){
         this.active = 0;
       }
       if (path === '/my'){
         this.active = 2;
       }
       if (path === '/contact'){
         this.active = 2;
       }
        if (path === '/rechargeable'){
          this.active = 2;
        }
        if (path === '/draw'){
         this.active = 2;
       }
        if (path === '/auditing'){
         this.active = 2;
       }
       if (path === '/income'){
         this.active = 2;
       }
       if (path === '/notice'){
         this.active = 2;
       }
    },
  },
};
</script>

<style lang="less" scoped>
 ::v-deep .van-tabbar-item--active {
  color: #15c8f0;
  background-color: #061731
}
::v-deep .van-tabbar {
  height: 60px;
}
.tabbar_icon {
  width: 35px; 
  height: 35px;
}
::v-deep .van-tabbar-item {
    font-size: 14px;
}
::v-deep [class*=van-hairline]::after {
  border: 0 solid #061731;
}
</style>